import React from "react";
import EquityModalNew from "./EquityModalNew";
import { tracker } from "../../services/mixpanel";

interface Props {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  handleClickNo: () => void;
  EQUITY_CONTRIBUTION_FAQ_LINK: string;
}

const EntitySetupPrompt = ({
  isOpen,
  setIsOpen,
  handleClickNo,
  EQUITY_CONTRIBUTION_FAQ_LINK,
}: Props) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div className="text-[17px] font-semibold px-8 text-center">
        An LLC entity is required to buy solar assets.
        <br />
        Do you have an existing entity to purchase the solar assets? If your
        answer is NO, we will setup an Entity for you.
      </div>

      <div className="flex mt-8 w-1/2 justify-evenly">
        <button
          className="bg-[#3B755E] text-[12px] rounded-sm text-white h-[32px] w-[48px]"
          onClick={() => setIsOpen(true)}
        >
          YES
        </button>
        {isOpen && <EquityModalNew onClose={() => setIsOpen(false)} />}
        <button
          className="bg-[#ff0000ad] rounded-sm text-[12px] text-white h-[32px] w-[48px]"
          onClick={handleClickNo}
        >
          NO
        </button>
      </div>

      {/* ✅ FAQ Button */}
      <div className="flex justify-center mt-4">
        <a
          href={EQUITY_CONTRIBUTION_FAQ_LINK}
          target="_blank"
          rel="noopener noreferrer"
          onClick={tracker.dashboard.equityContribution.FAQButton}
          className="bg-[#3B755E] text-white text-[12px] rounded-sm h-[32px] px-4 flex items-center justify-center"
        >
          Entity Setup Frequently Asked Questions
        </a>
      </div>
    </div>
  );
};

export default EntitySetupPrompt;
